"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.init = void 0;
var init = function () {
    var $carousel = $('.carousel-with-image');
    var owlCarousel = function () {
        $carousel.owlCarousel({
            items: 1,
            slideSpeed: 2000,
            nav: true,
            autoplay: false,
            dots: true,
            loop: false,
            navText: [
                '<img src="/app/themes/tedee/assets/images/arrow-gray-left.svg" alt="prev arrow" />',
                '<img src="/app/themes/tedee/assets/images/arrow-gray-right.svg" alt="next arrow" />'
            ],
            responsive: {
                560: {
                    items: 2
                },
                1000: {
                    items: 3
                },
                1200: {
                    items: 4
                },
            }
        });
    };
    owlCarousel();
};
exports.init = init;
